import React, { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { API, BASE_URL } from "../api";

import { FiEdit, FiPlus, FiCheckCircle } from "react-icons/fi";

import { toasts } from "../components/AppToast";

import Layout from "../components/Layout";

const YES_NO = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
];

const DOORS = [1, 2, 3, 4, 5, 6];

const PASS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const LUGG = [1, 2, 3, 4, 5, 6];

const EMPTY_FORM = {
  cat_id: "",
  carmodel_name: "",
  carmodel_brand: "",
  No_of_carmodel: 1,
  carmodel_desc: "",
  carmodel_passgrno: "",
  carmodel_luggno: "",
  carmodel_engcapacity: "",
  carmodel_doors: 4,
  driver_age: "",
  carmodel_transmission: "",
  carmodel_cntralLocking: "",
  carmodel_airconditionr: "",
  carmodel_stereo: "",
  carmodel_airbag: "",
  carmodel_elctricwindows: "",
  carmodel_dispinhome: 2,
  image_alt: "",
  chkseason: [],
  chkitem: [],
};

export default function AddCar() {
  const navigate = useNavigate();

  const location = useLocation();

  const editCar = location.state?.car || null;

  const editId = editCar?.carmodel_id || null;

  const isEdit = Boolean(editId);

  // SIDEBAR

  const [sideOpen, setSideOpen] = useState(true);

  const [activePage, setActivePage] = useState(isEdit ? "Edit Car" : "Add Car");

  const [user, setUser] = useState(null);

  // DROPDOWNS

  const [groups, setGroups] = useState([]);

  const [brands, setBrands] = useState([]);

  const [transmissions, setTransmission] = useState([]);

  const [engcapacitys, setEngcapacity] = useState([]);

  const [includedtems, setIncludedtems] = useState([]);

  const [seasons, setSeasons] = useState([]);

  // FORM

  const [form, setForm] = useState(EMPTY_FORM);

  const [saving, setSaving] = useState(false);

  const [imageFile, setImageFile] = useState(null);

  const [imagePreview, setImagePreview] = useState("");

  const fileRef = useRef();

  // AUTH

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");

      return;
    }

    setUser(JSON.parse(localStorage.getItem("user") || "null"));
  }, [navigate]);

  // LOAD GROUPS

  useEffect(() => {
    API.get("/cargroup", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setGroups(r.data.data || []))
      .catch(() => {});
  }, []);

  // LOAD BRANDS

  useEffect(() => {
    API.get("/brand", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setBrands(r.data.data || []))
      .catch(() => {});
  }, []);

  // LOAD TRANSMISSIONS

  useEffect(() => {
    API.get("/transmission", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setTransmission(r.data.data || []))
      .catch(() => {});
  }, []);

  // LOAD ENGINE CAPACITY

  useEffect(() => {
    API.get("/engcapacity", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setEngcapacity(r.data.data || []))
      .catch(() => {});
  }, []);

  // LOAD ITEMS

  useEffect(() => {
    API.get("/caritems", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setIncludedtems(r.data.data || []))
      .catch(() => {});
  }, []);

  // LOAD SEASONS

  useEffect(() => {
    API.get("/seasons/available", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => setSeasons(r.data.data || []))
      .catch((err) => console.error(err));
  }, []);

  // PARSE SELECTED VALUES

  const parseArray = (value) => {
    if (Array.isArray(value)) {
      return value.map(String);
    }

    if (!value) {
      return [];
    }

    try {
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      if (Array.isArray(parsed)) {
        return parsed.map(String);
      }

      return [];
    } catch (error) {
      console.error("Array parse error:", error);

      return [];
    }
  };

  // LOAD EDIT DATA INTO FORM

  useEffect(() => {
    if (!editCar) {
      setForm({
        ...EMPTY_FORM,
        chkseason: [],
        chkitem: [],
      });

      setImageFile(null);

      setImagePreview("");

      if (fileRef.current) {
        fileRef.current.value = "";
      }

      return;
    }

    const selectedSeasons = parseArray(editCar.selected_seasons);

    const selectedItems = parseArray(editCar.selected_items);

    setForm({
      cat_id: editCar.cat_id || "",

      carmodel_name: editCar.carmodel_name || "",

      carmodel_brand: editCar.carmodel_brand
        ? String(editCar.carmodel_brand)
        : "",

      No_of_carmodel: editCar.No_of_carmodel || 1,

      carmodel_desc: editCar.carmodel_desc || "",

      carmodel_passgrno: editCar.carmodel_passgrno || "",

      carmodel_luggno: editCar.carmodel_luggno || "",

      carmodel_engcapacity: editCar.carmodel_engcapacity
        ? String(editCar.carmodel_engcapacity)
        : "",

      carmodel_doors: editCar.carmodel_doors || 4,

      driver_age: editCar.driver_age || "",

      carmodel_transmission: editCar.carmodel_transmission
        ? String(editCar.carmodel_transmission)
        : "",

      carmodel_cntralLocking: editCar.carmodel_cntralLocking || "",

      carmodel_airconditionr: editCar.carmodel_airconditionr || "",

      carmodel_stereo: editCar.carmodel_stereo || "",

      carmodel_airbag: editCar.carmodel_airbag || "",

      carmodel_elctricwindows: editCar.carmodel_elctricwindows || "",

      carmodel_dispinhome: editCar.carmodel_dispinhome || 1,

      image_alt: editCar.image_alt || "",

      chkseason: selectedSeasons,

      chkitem: selectedItems,
    });

    setImageFile(null);

    if (fileRef.current) {
      fileRef.current.value = "";
    }

    if (editCar.carmodel_image) {
      setImagePreview(`${BASE_URL}/${editCar.carmodel_image}`);
    } else {
      setImagePreview("");
    }
  }, [editCar]);

  // FORM CHANGE

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // CHECKBOX

    if (type === "checkbox") {
      setForm((prev) => {
        const oldValues = Array.isArray(prev[name]) ? prev[name] : [];

        const newValue = String(value);

        if (checked) {
          return {
            ...prev,

            [name]: oldValues.includes(newValue)
              ? oldValues
              : [...oldValues, newValue],
          };
        }

        return {
          ...prev,

          [name]: oldValues.filter((id) => String(id) !== newValue),
        };
      });

      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // IMAGE

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      toasts.warning("Image size must be less than 2MB");

      e.target.value = "";

      return;
    }

    setImageFile(file);

    setImagePreview(URL.createObjectURL(file));
  };

  // SUBMIT

  const handleSubmit = async () => {
    if (!form.carmodel_name.trim()) {
      toasts.warning("Enter car name");

      return;
    }

    if (!form.cat_id) {
      toasts.warning("Select a group");

      return;
    }

    setSaving(true);

    try {
      const fd = new FormData();

      Object.entries(form).forEach(([key, value]) => {
        if (key === "chkseason" || key === "chkitem") {
          (value || []).forEach((id) => {
            fd.append(key, id);
          });
        } else {
          fd.append(key, value ?? "");
        }
      });

      if (imageFile) {
        fd.append("car_image", imageFile);
      }

      if (user?.user_id) {
        fd.append("user_id", user.user_id);
      }

      // =================================================
      // UPDATE
      // =================================================

      if (isEdit) {
        await API.put(`/cars/${editId}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        toasts.success("Car updated successfully");
      }

      // =================================================
      // ADD
      // =================================================
      else {
        await API.post("/cars", fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        toasts.success("Car added successfully");
      }

      // Go back to Manage Cars

      navigate("/manage-cars");
    } catch (err) {
      console.error(err);

      toasts.error(err.response?.data?.error || "Operation failed");
    } finally {
      setSaving(false);
    }
  };

  // SELECT

  const Sel = ({ name, value, options }) => (
    <select
      className="um-select"
      name={name}
      value={value}
      onChange={handleChange}
    >
      {options.map((o) => (
        <option key={o.value ?? o} value={o.value ?? o}>
          {o.label ?? o}
        </option>
      ))}
    </select>
  );

  // RENDER

  return (
    <Layout
      sideOpen={sideOpen}
      setSideOpen={setSideOpen}
      activePage={activePage}
      setActivePage={setActivePage}
      user={user}
    >
      <main className="dashboard-main">
        <div className="user-form-page">
          {/* HEADER
            ================================== */}

          <div className="user-form-header">
            <div className="d-flex align-items-center gap-2">
              <div className="form-card-icon">
                {isEdit ? <FiEdit size={24} /> : <FiPlus size={24} />}
              </div>

              <div>
                <h2 className="um-modal-title mb-0">
                  {isEdit ? "Edit Car" : "Add New Car"}
                </h2>

                <p className="form-card-sub mb-0">
                  {isEdit
                    ? "(Update car information and specifications)"
                    : "(Create a new car and set its specifications)"}
                </p>
              </div>
            </div>

            <button
              type="button"
              className="um-btn-secondary"
              onClick={() => navigate("/manage-cars")}
            >
              ← Back to Cars
            </button>
          </div>

          {/* FORM CARD
            ================================== */}

          <div className="user-form-card">
            {/*   BASIC INFORMATION*/}

            <div className="sec-div">
              <span>Basic Information</span>
            </div>

            <div className="row g-4">
              {/* CAR GROUP */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Car Group *</label>

                <select
                  className="um-select"
                  name="cat_id"
                  value={form.cat_id}
                  onChange={handleChange}
                >
                  <option value="">— Select Group —</option>

                  {groups.map((g) => (
                    <option key={g.cat_id} value={g.cat_id}>
                      {g.cat_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* CAR MODEL NAME */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Car Model Name *</label>

                <input
                  className="um-input"
                  type="text"
                  name="carmodel_name"
                  placeholder="e.g. Toyota Camry"
                  value={form.carmodel_name}
                  onChange={handleChange}
                />
              </div>

              {/* BRAND */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Brand *</label>

                <select
                  className="um-select"
                  name="carmodel_brand"
                  value={form.carmodel_brand}
                  onChange={handleChange}
                >
                  <option value="">— Select Brand —</option>

                  {brands.map((brand) => (
                    <option key={brand.mstmod_id} value={brand.mstmod_id}>
                      {brand.mstmod_val}
                    </option>
                  ))}
                </select>
              </div>

              {/* NUMBER OF CARS */}

              <div className="col-xl-3 col-lg-3 col-md-6">
                <label className="um-label">Number of Cars *</label>

                <input
                  className="um-input"
                  type="number"
                  min={1}
                  name="No_of_carmodel"
                  value={form.No_of_carmodel}
                  onChange={handleChange}
                />
              </div>

              {/* DESCRIPTION */}

              <div className="col-12">
                <label className="um-label">Description *</label>

                <textarea
                  className="um-input"
                  name="carmodel_desc"
                  placeholder="Car description..."
                  rows={3}
                  value={form.carmodel_desc}
                  onChange={handleChange}
                  style={{
                    resize: "vertical",
                  }}
                />
              </div>
            </div>

            {/*   SPECIFICATIONS*/}

            <div className="sec-div mt-4">
              <span>Specifications</span>
            </div>

            <div className="row g-4">
              {/* TRANSMISSION */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Transmission *</label>

                <select
                  className="um-select"
                  name="carmodel_transmission"
                  value={form.carmodel_transmission}
                  onChange={handleChange}
                >
                  <option value="">— Select —</option>

                  {transmissions.map((item) => (
                    <option key={item.mstmod_id} value={item.mstmod_id}>
                      {item.mstmod_val}
                    </option>
                  ))}
                </select>
              </div>

              {/* ENGINE CAPACITY */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Engine Capacity *</label>

                <select
                  className="um-select"
                  name="carmodel_engcapacity"
                  value={form.carmodel_engcapacity}
                  onChange={handleChange}
                >
                  <option value="">— Select —</option>

                  {engcapacitys.map((item) => (
                    <option key={item.mstmod_id} value={item.mstmod_id}>
                      {item.mstmod_val}
                    </option>
                  ))}
                </select>
              </div>

              {/* PASSENGERS */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Passenger</label>

                <Sel
                  name="carmodel_passgrno"
                  value={form.carmodel_passgrno}
                  options={PASS.map((v) => ({
                    value: v,
                    label: v,
                  }))}
                />
              </div>

              {/* LUGGAGE */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Luggage</label>

                <Sel
                  name="carmodel_luggno"
                  value={form.carmodel_luggno}
                  options={LUGG.map((v) => ({
                    value: v,
                    label: v,
                  }))}
                />
              </div>

              {/* DOORS */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Doors</label>

                <Sel
                  name="carmodel_doors"
                  value={form.carmodel_doors}
                  options={DOORS.map((v) => ({
                    value: v,
                    label: v,
                  }))}
                />
              </div>

              {/* DRIVER AGE */}

              <div className="col-xl-2 col-lg-2 col-md-6">
                <label className="um-label">Driver Age</label>

                <input
                  className="um-input"
                  type="number"
                  min={1}
                  name="driver_age"
                  value={form.driver_age}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/*   FEATURES*/}

            <div className="sec-div mt-4">
              <span>Features</span>
            </div>

            <div className="row g-4">
              {[
                {
                  name: "carmodel_cntralLocking",
                  label: "Central Locking",
                },

                {
                  name: "carmodel_airconditionr",
                  label: "AC",
                },

                {
                  name: "carmodel_stereo",
                  label: "Stereo",
                },

                {
                  name: "carmodel_airbag",
                  label: "Air Bags",
                },

                {
                  name: "carmodel_elctricwindows",
                  label: "Electric Windows",
                },

                {
                  name: "carmodel_dispinhome",
                  label: "Display Home Page",
                },
              ].map((item) => (
                <div key={item.name} className="col-xl-2 col-lg-2 col-md-6">
                  <label className="um-label">{item.label}</label>

                  <Sel
                    name={item.name}
                    value={form[item.name]}
                    options={
                      item.name === "carmodel_dispinhome"
                        ? [
                            {
                              value: 1,
                              label: "No",
                            },
                            {
                              value: 2,
                              label: "Yes",
                            },
                          ]
                        : YES_NO
                    }
                  />
                </div>
              ))}
            </div>

            {/*   SEASONS*/}

            <div className="sec-div mt-4">
              <span>Not Available For Following Seasons:</span>
            </div>

            <div className="mod-grid">
              {seasons.map((season) => {
                const checked =
                  Array.isArray(form.chkseason) &&
                  form.chkseason.includes(String(season.season_id));

                return (
                  <div
                    key={season.season_id}
                    className={`mod-chip ${checked ? "on" : ""}`}
                    onClick={() => {
                      handleChange({
                        target: {
                          name: "chkseason",
                          value: season.season_id,
                          type: "checkbox",
                          checked: !checked,
                        },
                      });
                    }}
                  >
                    <div className="chk">{checked}</div>

                    <span>{season.season_name}</span>
                  </div>
                );
              })}
            </div>

            {/*   INCLUDED ITEMS*/}

            <div className="sec-div mt-4">
              <span>Included Items Name:</span>
            </div>

            <div className="mod-grid">
              {includedtems.map((item) => {
                const checked =
                  Array.isArray(form.chkitem) &&
                  form.chkitem.includes(String(item.item_id));

                return (
                  <div
                    key={item.item_id}
                    className={`mod-chip ${checked ? "on" : ""}`}
                    onClick={() => {
                      handleChange({
                        target: {
                          name: "chkitem",
                          value: item.item_id,
                          type: "checkbox",
                          checked: !checked,
                        },
                      });
                    }}
                  >
                    <div className="chk">{checked}</div>

                    <span>{item.item_name}</span>
                  </div>
                );
              })}
            </div>

            {/*   CAR IMAGE*/}

            <div className="sec-div mt-4">
              <span>Car Image</span>
            </div>

            <div className="row g-4">
              <div className="col-12">
                <label className="um-label">
                  {isEdit ? "Change Image" : "Car Image"}
                </label>

                {/* EXISTING IMAGE */}

                {isEdit && imagePreview && (
                  <div className="mb-3">
                    <img
                      src={imagePreview}
                      alt="Existing Car"
                      crossOrigin="anonymous"
                      style={{
                        width: 160,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 8,
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}

                {/* FILE INPUT */}

                <input
                  ref={fileRef}
                  type="file"
                  accept="image/*"
                  className="um-input"
                  onChange={handleImageChange}
                />

                <small
                  className="d-block mt-1"
                  style={{
                    color: "#999",
                  }}
                >
                  JPG / PNG / WEBP, max 2MB
                </small>
              </div>

              {/* IMAGE PREVIEW */}

              {imagePreview && (
                <div className="col-12">
                  <label className="um-label">Preview</label>

                  <div>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      crossOrigin="anonymous"
                      style={{
                        width: 160,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 10,
                        border: "1px solid #eee",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            {/*   NOTE*/}

            <div
              className="mt-4 p-3"
              style={{
                background: "#fff5f5",
                border: "1px solid #ffd6d6",
                borderRadius: 8,
                color: "#dc3545",
              }}
            >
              <strong>Note:</strong>
              <br />
              1) Image Size Should Be Less Than 2MB.
              <br />
              2) Image Width And Height Should Be 320px and 200px Respectively.
            </div>

            {/*   FORM FOOTER*/}

            <div className="user-form-footer">
              <button
                type="button"
                className="um-btn-secondary"
                onClick={() => navigate("/manage-cars")}
                disabled={saving}
              >
                Cancel
              </button>

              <button
                type="button"
                className="um-btn-primary"
                onClick={handleSubmit}
                disabled={saving}
              >
                {saving ? (
                  <span className="spinner" />
                ) : isEdit ? (
                  <>
                    <FiCheckCircle />
                    Update Car
                  </>
                ) : (
                  <>
                    <FiPlus />
                    Add Car
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </main>
      
    </Layout>
  );
}
